<div class="card ribbone-card">
  <div *ngIf="isCurrentPlan" class="arrow-ribbone-left">Current Plan</div>

  <div class="card-body d-flex flex-column mt-2">
    <!-- Price Header -->
    <div class="price position-relative">
      <div class="d-flex align-items-center mb-2">
        <span class="d-flex align-items-center flex-wrap price-icon me-3">
          <i class="ti ti-arrow-big-up-line-filled fs-20"></i>
        </span>

        <p class="fs-20 d-flex align-items-center mb-0">
          {{ plan.name }}
        </p>
      </div>

      <div class="d-flex pt-2 mt-4 border-top">
        <div class="d-flex flex-column">
          @if (plan.discountValue > 0) {
            <h5 class="fs-24 text-gray-5 text-decoration-line-through">
              {{ plan.planCurrency?.currency_symbol || '$' }}
              {{ plan.originalPrice }}
            </h5>
          }

          <div>
            <span class="fs-1 text-dark fw-bold">
              {{ plan.planCurrency?.currency_symbol || '$' }}
              {{ plan.discountValue > 0 ? plan.price : (plan.originalPrice ?? plan.price) }}
            </span>

            <span class="text-gray-5 fs-14">
              User/{{ plan.type?.toUpperCase() === 'MONTHLY' ? 'Month' : 'Year' }}
            </span>
          </div>
        </div>
      </div>
    </div>

    <!-- Features -->
    <div class="mt-3 flex-grow-1">
      <div class="features-scroll">
        <ul class="ps-0">
          @for (feature of plan.featuresList; track $index) {
            <li class="d-flex align-items-start mb-2">
              <i class="ti {{ feature.icon }} me-2 {{ feature.colorClass }}"> </i>

              <div>
                {{ feature.text }}
              </div>
            </li>
          }
        </ul>
      </div>

      <!-- @if (plan.hasMoreFeatures) {
        <div class="more-features-container d-flex justify-content-end">
          <a class="more-features-link"> and {{ plan.hiddenFeaturesList.length }} more... </a>

          <div class="more-features-tooltip">
            <ul>
              @for (item of plan.hiddenFeaturesList; track $index) {
                <li class="mb-2">
                  {{ item.text }}
                </li>
              }
            </ul>
          </div>
        </div>
      } -->
    </div>

    <!-- <div class="mt-3 flex-grow-1">{{ plan.description }}</div> -->
    <!-- Buttons -->
    <div class="d-flex gap-2 mt-3">
      <!-- <button
        type="button"
        class="btn btn-outline-secondary w-50 trial-btn"
        (click)="onGetStarted()"
      >
        Free Trial
      </button> -->

      <button type="button" class="btn btn-primary w-100 buy-btn" (click)="onGetStarted()">
        Get Started
      </button>
    </div>
  </div>
</div>
